export const webPostVisibilityTypes = {
	all: -1,
	exclude: 0,
	include: 1,
} as const

export type WebPostVisibilityType = keyof typeof webPostVisibilityTypes
